module.exports = __webpack_public_path__ + "static/11-93e6fa734438f693d490ed77ffdae6ea.png";